import { useEffect } from "react";
import Input from "../../../../../components/input/Input";
import { Slider } from "primereact/slider";
import { Button } from "primereact/button";
import { ColorPicker } from "primereact/colorpicker";
import { Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { useWebsite } from "../Context/WebSiteContext";

const StatusObraSite = ({ control, setValue, watch }) => {
  const { updateFormData } = useWebsite();

  useEffect(() => {
    setValue("statusObra.currentStatus", "");
    setValue("statusObra.progressValue", 0);
  }, []);

  // Sempre use o valor do formulário para renderizar e atualizar
  const statusList = watch("statusObra.statusList") || [];

  // Adiciona estado para cor do título
  const titleColor = watch("statusObra.titleColor") || "#000000";

  // Função para atualizar cor do título
  const handleTitleColorChange = (hex) => {
    setValue("statusObra.titleColor", hex, { shouldDirty: true });
    updateFormData("statusObra", { titleColor: hex });
  };

  const handleAddStatus = () => {
    const currentStatus = watch("statusObra.currentStatus") || "";
    const progressValue = watch("statusObra.progressValue") || 0;

    if (currentStatus.trim() && progressValue > -1) {
      const newStatus = {
        id: `${Date.now()}_${Math.floor(Math.random() * 100000)}`,
        status: currentStatus,
        percentage: progressValue,
      };

      const updatedStatusList = [...statusList, newStatus];

      updateFormData("statusObra", {
        statusList: updatedStatusList,
        currentStatus: "",
        progressValue: 0,
      });

      setValue("statusObra.statusList", updatedStatusList, {
        shouldDirty: true,
      });
      setValue("statusObra.currentStatus", "", { shouldDirty: true });
      setValue("statusObra.progressValue", 0, { shouldDirty: true });
    }
  };

  const handleRemoveStatus = (id) => {
    const currentList = watch("statusObra.statusList") || [];
    const updatedStatusList = currentList.filter(
      (item) => String(item.id) !== String(id)
    );

    updateFormData("statusObra", {
      statusList: updatedStatusList,
    });

    setValue("statusObra.statusList", updatedStatusList, { shouldDirty: true });
  };

  return (
    <>
      <div className="row">
        <div className="col-6 mb-3">
          <h5 className="mb-2">Cor do título</h5>
          <div className="d-flex flex-row align-items-center gap-2">
            <Controller
              name="statusObra.titleColor"
              control={control}
              defaultValue={titleColor}
              render={({ field }) => (
                <>
                  <ColorPicker
                    value={field.value?.replace("#", "")}
                    onChange={(e) => {
                      const hex = "#" + e.value;
                      field.onChange(hex);
                      handleTitleColorChange(hex);
                    }}
                    format="hex"
                  />
                  <InputText
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      handleTitleColorChange(e.target.value);
                    }}
                    placeholder="#000000"
                    className="w-100 text-center"
                  />
                </>
              )}
            />
          </div>
        </div>
        <div className="col-6 mb-3">
          <h5 className="mb-2">Cor da barra de progresso</h5>
          <div className="d-flex flex-row align-items-center gap-2">
            <Controller
              name="statusObra.progressColor"
              control={control}
              defaultValue={watch("statusObra.progressColor") || "#40d663"}
              render={({ field }) => (
                <>
                  <ColorPicker
                    value={field.value?.replace("#", "")}
                    onChange={(e) => {
                      const hex = "#" + e.value;
                      field.onChange(hex);
                      setValue("statusObra.progressColor", hex, { shouldDirty: true });
                      updateFormData("statusObra", { progressColor: hex });
                    }}
                    format="hex"
                  />
                  <InputText
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      setValue("statusObra.progressColor", e.target.value, { shouldDirty: true });
                      updateFormData("statusObra", { progressColor: e.target.value });
                    }}
                    placeholder="#40d663"
                    className="w-100 text-center"
                  />
                </>
              )}
            />
          </div>
        </div>
        <div className="col-12 d-flex align-items-center mb-3 gap-3">
          <h5 style={{ marginBottom: 0 }}>
            Adicione os status de obra do seu empreendimento
          </h5>
        </div>
        <div className="col-md-6 mt-3">
          <Input
            label="Status de Obra"
            control={control}
            name="statusObra.currentStatus"
            className="form-control"
            defaultValue=""
            onChange={(e) => {
              setValue("statusObra.currentStatus", e.target.value, {
                shouldDirty: true,
              });
            }}
          />
        </div>
        <div className="col-md-6 mt-5">
          <Slider
            value={watch("statusObra.progressValue") || 0}
            onChange={(e) => {
              setValue("statusObra.progressValue", e.value, {
                shouldDirty: true,
              });
            }}
          />
          <span>{watch("statusObra.progressValue") || 0}%</span>
        </div>
        <div>
          <Button
            type="button"
            label="Adicionar Status"
            icon="pi pi-plus"
            className="p-button-primary p-button-rounded p-3 mt-5"
            onClick={handleAddStatus}
          />
        </div>
        <div className="mt-4 w-100">
          {statusList.map((item) => (
            <div key={item.id} className="row align-items-center mb-2">
              <div className="col-md-4">{item.status}</div>
              <div className="col-md-4">{item.percentage}%</div>
              <div className="col-md-4">
                <Button
                  type="button"
                  label="Excluir"
                  icon="pi pi-trash"
                  className="p-button-danger p-button-rounded"
                  onClick={() => handleRemoveStatus(item.id)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StatusObraSite;
